import type { ToolSSEvent } from "@/lib/queries/tools/useToolSubmissionSSE";
import type { DocumentStatusItem } from "@/components/results/DocumentStatuses";

export type MinimalResult = {
  type: string;
  language: string;
  body: string;
  format: string;
};

export function buildDocStatuses(params: {
  expectedDocs?: { type: string; language: string }[];
  sseEvents?: ToolSSEvent[];
  results?: MinimalResult[];
  isStreaming?: boolean;
  isLoading?: boolean;
  includePlaceholder?: boolean; // default true
}): DocumentStatusItem[] {
  const {
    expectedDocs = [],
    sseEvents = [],
    results = [],
    isStreaming = false,
    isLoading = false,
    includePlaceholder = true,
  } = params || ({} as any);

  type Key = string;
  const map = new Map<Key, DocumentStatusItem>();

  expectedDocs.forEach((d) => {
    if (!d?.type || !d?.language) return;
    const key = `${d.type}__${(d.language || "").toLowerCase()}`;
    if (!map.has(key)) {
      map.set(key, { type: d.type, language: d.language, status: "generating" });
    }
  });

  sseEvents.forEach((ev) => {
    if (ev.type === "output") {
      const res: any = (ev as any)?.body?.result;
      if (!res || !res.type || !res.language) return;
      const key = `${res.type}__${(res.language || "").toLowerCase()}`;
      map.set(key, { type: res.type, language: res.language, status: "ready" });
    }
    if (ev.type === "complete") {
      const list: any[] = ((ev as any)?.body?.results || []).filter(Boolean);
      list.forEach((r) => {
        if (!r?.type || !r?.language) return;
        const key = `${r.type}__${(r.language || "").toLowerCase()}`;
        map.set(key, { type: r.type, language: r.language, status: "ready" });
      });
    }
  });

  results.forEach((r) => {
    if (!r?.type || !r?.language) return;
    const key = `${r.type}__${(r.language || "").toLowerCase()}`;
    map.set(key, { type: r.type, language: r.language, status: "ready" });
  });

  if (includePlaceholder && map.size === 0 && (isStreaming || isLoading)) {
    map.set("__current__", { type: "Document", language: "", status: "generating" });
  }

  return Array.from(map.values());
}
